import * as React from 'react';
import { Component, createElement, Fragment } from 'react';
import { hydration, consumer } from '@emotion/core';
import { getRegisteredStyles, insertStyles } from '@emotion/utils';
import { serializeStyles } from '@emotion/serialize';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _componentDidMount() {
  hydration.shouldHydrate = false;
}

function _render() {
  return consumer(this, this.renderChild);
}

var Style =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Style, _React$Component);

  function Style(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _initialiseProps.call(_assertThisInitialized(_this));

    _this.shouldHydrate = hydration.shouldHydrate;
    return _this;
  }

  var _proto = Style.prototype;
  _proto.componentDidMount = _componentDidMount;
  _proto.render = _render;
  return Style;
}(Component); // $FlowFixMe


var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  Object.defineProperty(this, "renderChild", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(context) {
      var _this2$props = _this2.props,
          props = _this2$props.props,
          type = _this2$props.type,
          children = _this2$props.children;
      var actualProps = props || {};
      var registeredStyles = [];
      var className = '';

      if (actualProps.className !== undefined) {
        className = getRegisteredStyles(context.registered, registeredStyles, actualProps.className);
      }

      registeredStyles.push(typeof actualProps.css === 'function' ? actualProps.css(context.theme) : actualProps.css);
      var serialized = serializeStyles(registeredStyles);
      var rules = insertStyles(context, serialized);
      className += serialized.cls;

      if (_this2.serialized === undefined && _this2.shouldHydrate) {
        _this2.serialized = rules;
      }

      var newProps = _extends({}, actualProps, {
        className: className
      });

      delete newProps.css;
      var ele = createElement.apply(React, [type, newProps].concat(children));

      if (_this2.serialized !== undefined) {
        return createElement(Fragment, null, createElement("style", {
          "data-more": "",
          dangerouslySetInnerHTML: {
            __html: _this2.serialized
          }
        }), ele);
      }

      return ele;
    }
  });
};

var jsx = function jsx(type, props) {
  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  if (props == null || props.css == null || type.__emotion_component === true) {
    return createElement.apply(React, [type, props].concat(children));
  }

  if (typeof props.css === 'string' && process.env.NODE_ENV !== 'production') {
    throw new Error("Strings are not allowed as css prop values, please wrap it in a css template literal from '@emotion/css' like this: css`" + props.css + "`");
  }

  return createElement(Style, {
    props: props,
    type: type,
    children: children
  });
};

export default jsx;
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@emotion/jsx/dist/index.es.js